import React from 'react'
import { applyAvatarImageFallback, baseURLImage, getNameProfile } from 'Utils/utils';

const ParticipantCard = ({item}) => {
    const handleImageError = (e, fname, lname) => {
        applyAvatarImageFallback(e, fname, lname);
      };
  return (
    <div className='flex items-center gap-2'>
      <div className='h-10 w-10 flex-shrink-0'>
        <img
          onError={(e) => handleImageError(e, item?.first_name, item?.last_name)}
          loading='lazy'
          
          className='object-cover h-10 w-10 rounded-full'
          src={
            item?.profile_picture
              ? baseURLImage(item?.profile_picture)
              : getNameProfile(item?.first_name, item?.last_name)
          }
          alt=''
        />
      </div>
      <span className='text-gray-500 capitalize text-sm font-semibold'>
        {item?.name ? item.name : `${item?.first_name} ${item?.last_name}`}
      </span>
    </div>
  )
}

export default ParticipantCard
